import { ZodIsoDate, ZodIsoInstant, ZodIsoDateTime, ZodIsoTime, ZodIsoYearMonth, ZodIsoMonthDay, ZodIsoDuration } from './iso-z';
import { ExtendZod } from './zod-extension';
import { z } from 'zod';
import { ZodInit } from './zod-init';
import { InitDefaults } from './init-defaults';
import { ZodLabel } from './zod-label';
import { ZodEnumLabels } from './zod-enum-labels';
import { LabelDefaults } from './label-defaults';
import { ZodCFV } from './zod-cfv';
import './zod-custom-errors';
ExtendZod(z.ZodString, ZodLabel(LabelDefaults.string), ZodInit(InitDefaults.string));
ExtendZod(z.ZodNumber, ZodLabel(LabelDefaults.number), ZodInit(InitDefaults.number));
ExtendZod(z.ZodBoolean, ZodLabel(LabelDefaults.boolean), ZodInit(InitDefaults.boolean));
ExtendZod(z.ZodLiteral, ZodLabel(LabelDefaults.literal), ZodInit(InitDefaults.literal));
ExtendZod(z.ZodEnum, ZodLabel(LabelDefaults.enum), ZodInit(InitDefaults.enum), ZodEnumLabels);
ExtendZod(z.ZodNull, ZodLabel(LabelDefaults.null), ZodInit(InitDefaults.null));
ExtendZod(z.ZodNullable, ZodLabel(LabelDefaults.nullable), ZodInit(InitDefaults.nullable));
ExtendZod(z.ZodObject, ZodLabel(LabelDefaults.object), ZodInit(InitDefaults.object), ZodCFV);
ExtendZod(z.ZodArray, ZodLabel(LabelDefaults.array), ZodInit(InitDefaults.array));
ExtendZod(z.ZodRecord, ZodLabel(LabelDefaults.record), ZodInit(InitDefaults.record));
ExtendZod(z.ZodUnion, ZodLabel(LabelDefaults.union), ZodInit(InitDefaults.union));
ExtendZod(z.ZodTuple, ZodLabel(LabelDefaults.tuple), ZodInit(InitDefaults.tuple));
ExtendZod(z.ZodOptional, ZodLabel(LabelDefaults.optional), ZodInit(InitDefaults.optional));
ExtendZod(z.ZodLazy, ZodLabel(LabelDefaults.lazy), ZodInit(InitDefaults.lazy));
ExtendZod(z.ZodEffects, ZodLabel(LabelDefaults.effects), ZodInit(InitDefaults.effects));
ExtendZod(z.ZodAny, ZodLabel(LabelDefaults.any), ZodInit(InitDefaults.any));
export * from 'zod';
export { isoZ } from './iso-z';
export function GetZodBaseType(type) {
    if (type instanceof z.ZodNullable) {
        return GetZodBaseType(type.unwrap());
    }
    else if (type instanceof z.ZodOptional) {
        return GetZodBaseType(type.unwrap());
    }
    else if (type instanceof z.ZodEffects) {
        return GetZodBaseType(type.innerType());
    }
    else if (type instanceof z.ZodLazy) {
        return GetZodBaseType(type._def.getter());
    }
    else {
        return type;
    }
}
function BuildSchemaTypeGuards() {
    function String(schema) {
        return schema instanceof z.ZodString;
    }
    function Number(schema) {
        return schema instanceof z.ZodNumber;
    }
    function Boolean(schema) {
        return schema instanceof z.ZodBoolean;
    }
    function Literal(schema) {
        return schema instanceof z.ZodLiteral;
    }
    function Enum(schema) {
        return schema instanceof z.ZodEnum;
    }
    function Null(schema) {
        return schema instanceof z.ZodNull;
    }
    function Nullable(schema) {
        return schema instanceof z.ZodNullable;
    }
    function Object(schema) {
        return schema instanceof z.ZodObject;
    }
    function Array(schema) {
        return schema instanceof z.ZodArray;
    }
    function Record(schema) {
        return schema instanceof z.ZodRecord;
    }
    function Union(schema) {
        return schema instanceof z.ZodUnion;
    }
    function Tuple(schema) {
        return schema instanceof z.ZodTuple;
    }
    function Lazy(schema) {
        return schema instanceof z.ZodLazy;
    }
    function Optional(schema) {
        return schema instanceof z.ZodOptional;
    }
    function Effects(schema) {
        return schema instanceof z.ZodEffects;
    }
    function IsoInstant(schema) {
        return schema instanceof ZodIsoInstant;
    }
    function IsoDateTime(schema) {
        return schema instanceof ZodIsoDateTime;
    }
    function IsoDate(schema) {
        return schema instanceof ZodIsoDate;
    }
    function IsoTime(schema) {
        return schema instanceof ZodIsoTime;
    }
    function IsoYearMonth(schema) {
        return schema instanceof ZodIsoYearMonth;
    }
    function IsoMonthDay(schema) {
        return schema instanceof ZodIsoMonthDay;
    }
    function IsoDuration(schema) {
        return schema instanceof ZodIsoDuration;
    }
    function ZodJson(schema) {
        return (String(schema) ||
            Number(schema) ||
            Boolean(schema) ||
            Literal(schema) ||
            Enum(schema) ||
            Null(schema) ||
            Nullable(schema) ||
            Object(schema) ||
            Array(schema) ||
            Record(schema) ||
            Union(schema) ||
            Tuple(schema) ||
            Lazy(schema) ||
            Optional(schema) ||
            Effects(schema) ||
            IsoInstant(schema) ||
            IsoDateTime(schema) ||
            IsoDate(schema) ||
            IsoTime(schema) ||
            IsoYearMonth(schema) ||
            IsoMonthDay(schema) ||
            IsoDuration(schema));
    }
    return {
        ZodJson,
        String,
        Number,
        Boolean,
        Literal,
        Enum,
        Null,
        Nullable,
        Object,
        Array,
        Record,
        Union,
        Tuple,
        Lazy,
        Optional,
        Effects,
        IsoInstant,
        IsoDateTime,
        IsoDate,
        IsoTime,
        IsoYearMonth,
        IsoMonthDay,
        IsoDuration
    };
}
export const SchemaTypeGuards = BuildSchemaTypeGuards();
